import dayjs from 'dayjs'
import { useTranslation } from 'next-i18next'
import { memo, FC, useMemo } from 'react'
import type { TopListItem } from 'api-price'
import { coinImageUrl, formatAddString } from '@/utils/tools'
import { Flex } from '@mantine/core'
import useLangPrefix from '@/hooks/useLangPrefix'
import { useCountDown } from 'ahooks'
import BaseRiseColor from '@/components/BaseRiseColor'
import BaseImage from '@/components/BaseImage'
import { eventTracker } from '@/utils/collectEvent'
import { CoinListItemStyled, CoinListCurrencyItemStyled } from './style'
import { COIN_ICON_URL } from '@/constants/index'
import { EnumCoinTopTabs, recordTabsMap } from '@/blocks/Price/PriceRec/CoinList/data'

// eslint-disable-next-line react/display-name
const CoinListItem: FC<TopListItem & { onPageChange?: (type?: '+' | '-') => void; currentTabs: EnumCoinTopTabs }> = ({
  onPageChange,
  currentTabs,
  ...item
}) => {
  const { t } = useTranslation()
  const { langPrefix } = useLangPrefix()

  useCountDown({
    targetDate: (item.buy_start_timest ?? 0) * 1000,
    onEnd() {
      onPageChange?.()
    },
  })

  const priceNewClassName = useMemo((): string => {
    const isNew = item?.buy_start_timest && !dayjs().isAfter(dayjs(item.buy_start_timest * 1000))

    return isNew ? 'price-coin-new-item' : ''
  }, [item?.buy_start_timest])

  /**
   * @description: 当前代币点击
   * @return {*}
   */
  const handleCurrencyItemClick = () => {
    eventTracker('price_overview_click', {
      tab_name: recordTabsMap[currentTabs],
      currency_abbreviation: item?.coin_short_name,
    })
    window.open(`${langPrefix}/trade/${item?.coin_short_name?.toLocaleUpperCase()}_USDT`, '_blank')
  }

  if (item.coin_short_name === 'FHE') {
    console.log(
      '🚀 coinImageUrl(item?.logo_url, item?.coin_short_name):',
      coinImageUrl(item?.logo_url, item?.coin_short_name)
    )
  }

  return (
    <CoinListItemStyled data-isnew={'true'} {...{ component: 'li' }}>
      <CoinListCurrencyItemStyled onClick={handleCurrencyItemClick} className={`price-coin-item ${priceNewClassName}`}>
        <Flex gap={8} align="center">
          <BaseImage
            style={{ borderRadius: '50%' }}
            width={24}
            height={24}
            src={coinImageUrl(item?.logo_url, item?.coin_short_name)}
            coin={item?.coin_short_name}
          />
          <span className="text-1 size-16 font-500">{item?.coin_short_name ?? '--'}</span>
        </Flex>

        {item.buy_start_timest && priceNewClassName ? (
          <Flex direction={'column'} align={'flex-end'} gap={6}>
            <span className="size-12 font-400 text-funct-4">{t('P.OpeningTime')}</span>
            <span className="size-12 font-500 text-funct-4">
              {dayjs(item.buy_start_timest * 1000).format('YYYY-MM-DD HH:mm:ss')}
            </span>
          </Flex>
        ) : (
          <BaseRiseColor value={Number(item?.dimension_24h)}>
            <span>{formatAddString(item?.dimension_24h)}</span>
          </BaseRiseColor>
        )}
      </CoinListCurrencyItemStyled>
    </CoinListItemStyled>
  )
}

export default memo(CoinListItem)
